<template>
    <div class="item-select">
        <slot name="trigger-button" :toggleMenu="toggleMenu" :selectedItems="selectedItems">
            <button @click="toggleMenu" class="trigger-button">
                <span>{{ selectedItems.length > 0 ? `${selectedItems.length} plans selected` : 'Select an item' }}</span>
            </button>
        </slot>

        <transition name="fade">
            <div v-if="showMenu" class="item-menu">
                <input type="text" v-model="searchQuery" class="search-bar" placeholder="Search" />

                <div class="item-list" :style="menuHeight !== null ? { maxHeight: menuHeight } : {}">
                    <ul class="item-list-items">
                        <li v-if="filteredItems.length === 0" class="no-items">
                            No items found
                        </li>
                        <li v-for="(item, index) in filteredItems" :key="item.id" @click="selectItem(item)"
                            class="item-item">

                            <slot name="item-builder" :item="item">
                                <div class="item-title">
                                    <span>{{ item.title }}</span>
                                </div>
                            </slot>

                            <span v-if="isSelected(item)" class="circle-tick"></span>
                        </li>

                    </ul>
                </div>
            </div>
        </transition>
    </div>
</template>
  
  
<script>
export default {
    props: {
        items: {
            type: Array,
            required: true,
        },
        initialItems: {
            type: Array,
            default: () => [],
        },
        searchKeys: {
            type: Array,
            default: () => ['title'],
        },
        menuHeight: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            selectedItems: this.initialItems,
            searchQuery: '',
            showMenu: false,
        };
    },
    computed: {
        filteredItems() {
            if (!this.searchQuery) {
                return this.items;
            }
            const query = this.searchQuery.toLowerCase();

            return this.items.filter(item =>
                this.searchKeys.some(key =>
                    String(item[key] || '').toLowerCase().includes(query)
                )
            );
        },
    },
    watch: {
        initialItems(newItems) {
            this.selectedItems = newItems;
        },
    },
    methods: {
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        selectItem(item) {
            const index = this.selectedItems.findIndex(selectedItem => selectedItem.id === item.id);
            if (index === -1) {
                this.selectedItems.push(item);
            } else {
                this.selectedItems.splice(index, 1);
            }
            this.$emit('items-changed', this.selectedItems);
        },
        isSelected(item) {
            return this.selectedItems.some(selectedItem => selectedItem.id === item.id);
        },
        handleOutsideClick(event) {
            if (this.$el.contains(event.target)) {
                return;
            }
            this.showMenu = false;
        },
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideClick);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
    },
};
</script>

  
  
<style scoped>
.item-select {
    position: relative;
    max-width: 746px;
    width: -webkit-fill-available;

}

.trigger-button {
    padding: 10px;
    border: 1px solid #ccc;
    background-color: white;
    cursor: pointer;
    width: 100%;
    text-align: left;
    border-radius: 5px;
}

.item-menu {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 5px;
    overflow: hidden;
    z-index: 10;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    animation: fadeIn 0.3s forwards;
}

.item-list {
    max-height: calc(70vh - var(--header-height));
    overflow-y: auto;
}

.search-bar {
    padding: 10px;
    margin-bottom: 2px;
    width: 100%;
    font-size: small;
    height: 42px;
    border-radius: 6px;
    border: none;
}

.item-list-items {
    list-style-type: none;
    padding: 0;
}

.item-item {
    padding: 10px;
    border-bottom: 1px solid #eee;
    padding-right: 20px;
    cursor: pointer;
}

.no-items {
    padding: 10px;
    color: #888;
    text-align: center;
}

.item-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #eee;
    padding-right: 20px;
    cursor: pointer;
}

.circle-tick {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: var(--primary-color);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.circle-tick::after {
    content: "✔";
    color: #fff;
    font-size: 12px;
    font-weight: bold;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
        transform: translateY(0);
    }

    to {
        opacity: 0;
        transform: translateY(-10px);
    }
}

.fade-leave-active {
    animation: fadeOut 0.3s forwards;
}
</style>